import { type VideoContentObject, createVideoContentObject } from 'models';
import { useQuery } from 'query';
import { getVideoDetail } from '../services';
import { getVideoDetailQueryKey } from './keys';

export const useGetVideoDetailQuery = (videoId: string) =>
  useQuery<VideoContentObject>({
    async queryFn() {
      const { data } = await getVideoDetail(videoId);

      return createVideoContentObject(data);
    },
    queryKey: getVideoDetailQueryKey({ videoId }),
  });
